import './FooterMobile.scss'
import { useState } from 'react'
import { DangKyDangNhapMobile } from '../../../LayoutMobile/DangKyDangNhapMobile'
import { useNavigate, useLocation } from 'react-router-dom'
import Loading from '../../../component/Loading/Loading'
import {
  getFromlocalstorage,
  getFromsessionstorage
} from '../../../component/MaHoaDuLieu'
import { getApiUrl } from '../../../api/api'

function FooterMobile () {
  const [tab, settab] = useState('Đăng nhập')
  const [isOpen, setisOpen] = useState(false)
  const dangnhap = localStorage.getItem('dangnhap')
  const navigate = useNavigate()
  const location = useLocation()
  const device = window.innerWidth > 540 ? 'd' : 'm'
  const userdata =
    JSON.parse(getFromsessionstorage('data_u')) ||
    JSON.parse(getFromlocalstorage('data_u'))
  const [isLoading, setisLoading] = useState(false)

  const handelNavigateTk = () => {
    if (!dangnhap) {
      setisOpen(true)
    } else {
      navigate('/usermobile')
    }
  }

  const tabs = [
    {
      icon: 'icon_home',
      label: 'หน้าหลัก',
      path: '/',
      onClick: () => navigate('/')
    },
    {
      icon: 'icon_lottery',
      label: 'สล็อต',
      path: '/nohumobile',
      onClick: () => {
        if (!dangnhap) {
          setisOpen(true)
          settab('Đăng nhập')
        } else {
          navigate('/game_list_mobile?tab=PG&game=nohu')
        }
      }
    },
    {
      icon: 'icon_live',
      label: 'คาสิโน',
      path: '/casinomobile',
      onClick: () => {
        if (!dangnhap) {
          setisOpen(true)
          settab('Đăng nhập')
        } else {
          hanldePostWidthdraw('SeamlessGame', '7', '0')
        }
      }
    },
    {
      icon: 'icon_thethao',
      label: 'กีฬา',
      path: '/thethaomopbile',
      onClick: () => {
        if (!dangnhap) {
          setisOpen(true)
          settab('Đăng nhập')
        } else {
          hanldePostWidthdraw('ThirdPartySportsBook', '44', '0')
        }
      }
    },
    {
      icon: 'icon_user',
      label: 'ของฉัน',
      path: '/usermobile',
      onClick: handelNavigateTk
    }
  ]

  const hanldePostWidthdraw = async (portfolio, gameProviderId, gameId) => {
    try {
      setisLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/launch_game`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          portfolio: portfolio,
          device,
          gameProviderId,
          gameId,
          userData: userdata,
          productId: null
        })
      })
      const data = await response.json()

      if (data.message) {
        setisLoading(false)
        alert(data.message)
      } else {
        if (data.url) {
          window.location.href = data.url
          setisLoading(false)
        }
      }
    } catch (error) {
      setisLoading(false)
      console.error('Failed to fetch API: ', error)
    }
  }

  return (
    <>
      <Loading isLoading={isLoading} />
      <ul className='footermobile'>
        {tabs.map(({ icon, label, path, onClick }) => {
          const isActive = location.pathname === path
          return (
            <li key={label} onClick={onClick}>
              <i className={`${icon} ${isActive ? 'active' : ''}`}></i>
              <p className={`texttint ${isActive ? 'tintcolor' : ''}`}>
                {label}
              </p>
            </li>
          )
        })}
      </ul>
      <DangKyDangNhapMobile
        tab={tab}
        isOpen={isOpen}
        onClose={() => setisOpen(false)}
        settab={settab}
      />
    </>
  )
}

export default FooterMobile
